import type {
  Composition,
  Library,
  Practitioner,
  Reference,
} from '@medplum/fhirtypes'
import { codeableConcept } from '#src/codeableConcept.ts'
import { SEEN_HEALTH_SYSTEM } from '#src/codeSystems.ts'
import {
  ExtendedProvenance,
  ProvenanceParticipantType,
} from '#src/models/provenance.ts'

export class TemplateProvenance extends ExtendedProvenance {
  constructor({
    composition,
    template,
    author,
  }: {
    composition: Reference<Composition>
    template: Reference<Library>
    author: Reference<Practitioner>
  }) {
    super({
      target: composition,
      who: author,
      type: ProvenanceParticipantType.AUTHOR,
      entity: [
        {
          role: 'source',
          what: template,
        },
      ],
      activity: codeableConcept({
        system: ExtendedProvenance.ACTIVITY_SYSTEM,
        code: TemplateProvenance.ACTIVITY_CODE,
      }),
    })
  }

  static readonly PROFILE_URL = `${SEEN_HEALTH_SYSTEM}/StructureDefinition/template-provenance`

  static readonly ACTIVITY_CODE = 'template-instantiation'
}
